module.exports = __webpack_public_path__ + "img/pscBox31.52291993.png";